import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { jmd } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

export function ArtDepositButton({ p }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [cfg, setCfg] = useState({ deposit_pct: 30 });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/platform/art-deposit/config").then(({ data }) => setCfg(data)).catch(() => {}); }, []);
  const deposit = Math.round((p.price * cfg.deposit_pct) / 100);
  const reserve = async () => {
    if (!user) return navigate("/login?next=" + encodeURIComponent(window.location.pathname));
    if (!window.confirm(`Reserve "${p.name}" with a ${cfg.deposit_pct}% deposit of ${jmd(deposit)}? Balance ${jmd(p.price - deposit)} is invoiced when the artwork is received by SHOP NOW (sourcing up to ~1 month).`)) return;
    setBusy(true);
    try { const { data } = await api.post("/platform/art-deposit", { product_id: p.id, address: { full_name: user.name || "", line1: "", city: "Kingston", parish: "Kingston", country: "Jamaica", phone: "" } }); toast.success(`Reserved · order ${data.order_no} · deposit ${jmd(data.deposit)}`); navigate(`/track?order=${data.order_no}`); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not reserve"); } finally { setBusy(false); }
  };
  return (
    <div className="flex-1 space-y-2" data-testid="art-deposit-block">
      <button onClick={reserve} disabled={busy} data-testid="art-deposit-btn" className="w-full flex items-center justify-center gap-2 bg-ink text-white rounded-xl py-3 font-semibold hover:bg-[#E11B22] transition-colors disabled:opacity-60">Reserve with {cfg.deposit_pct}% deposit · {jmd(deposit)}</button>
      <p className="text-[11px] text-amber-900 bg-amber-50 border border-amber-200 rounded-lg p-2 inline-flex items-start gap-1.5" data-testid="art-deposit-notice"><Clock size={12} className="mt-0.5 shrink-0" /> Sourced from Cuba — up to ~1 month. Balance {jmd(p.price - deposit)} due when received by SHOP NOW. No fixed delivery date is promised until logistics confirms.</p>
    </div>
  );
}
